<template>
  <div>
    <el-tabs v-model="datas.status" type="card" @tab-click="search">
      <!--  状态-->
      <el-tab-pane v-for="(item, index) in statusList" :key="index" :label="item.value"
        :name="item.key + ''"></el-tab-pane>
    </el-tabs>
    <!--  搜索-->
    <div class="search">
      <!-- 开始日期-->
      <div class="item">
        <el-date-picker v-model="datas.created_at_start" :placeholder="$t('message.startDate')" class="Container"
          type="datetime" default-time="['00:00:00']" value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
      </div>
      <!--  结束日期-->
      <div class="item">
        <el-date-picker v-model="datas.created_at_end" :placeholder="$t('message.dateClosed')" class="Container"
          default-time="['23:59:59']" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
      </div>
      <div class="item">
        <!--  搜索 -->
        <el-button type="primary" @click="search">
          {{ $t("message.search") }}
        </el-button>
        <!--  重置 -->
        <el-button @click="reset">{{ $t("message.reset") }}</el-button>
      </div>
    </div>
    <!-- 列表 -->
    <div class="table">
      <el-table :data="tableData" style="width: 100%" :header-cell-style="{ background: '#EDEFF4' }">
        <el-table-column prop="rowNumber" label="NO" width="60" align="center">
        </el-table-column>
        <!-- 配送单号 -->
        <el-table-column align="center" :label="$t('message.porderNumber')" width="190px">
          <template slot-scope="scope">
            <p>
              <router-link :to="'/porderDetail?is_japanfirm=1&porder_sn=' + scope.row.porder_sn" target="_blank">
                {{ scope.row.porder_sn }}
              </router-link>
            </p>
            <p>{{ scope.row.user.realname }}</p>
          </template>
        </el-table-column>
        <!-- 订单号 -->
        <el-table-column align="center" :label="$t('message.orderNumber')" width="180px">
          <template slot-scope="scope">
            <p v-for="(item, index) in scope.row.porder_detail" :key="index">
              <router-link :to="'/orderPaymentDetail?is_japanfirm=1&order_sn=' + item.order_sn" target="_blank">
                {{ item.order_sn }}
              </router-link>
            </p>
          </template>
        </el-table-column>
        <!-- 操作员 -->
        <el-table-column align="center" :label="$t('message.operator')" width="130">
          <template slot-scope="scope">
            <div class="name">
              <span>{{ $t("message.salesman") }}:</span>
              {{ scope.row.y_admin != null ? scope.row.y_admin.realname : '' }}
            </div>
            <div class="name">
              <span>{{ $t("message.buyer") }}:</span>
              {{ scope.row.g_admin != null ? scope.row.g_admin.realname : '' }}
            </div>
            <div class="name">
              <span>{{ $t("message.distributionMember") }}:</span>
              {{ scope.row.p_admin != null ? scope.row.p_admin.realname : '' }}
            </div>
          </template>
        </el-table-column>
        <!-- 配送单状态 -->
        <el-table-column align="center" :label="$t('message.porderStatus')" prop="statusName">
        </el-table-column>
        <!-- 配送单提交 -->
        <el-table-column align="center" :label="$t('message.porderSubmit')" width="90" prop="created_at">
        </el-table-column>
        <!-- 配送单翻译 -->
        <el-table-column align="center" :label="$t('message.porderTranslate')" width="90"
          prop="porder_time_node.datetime_translate">
        </el-table-column>
        <!-- 配送单装箱 -->
        <el-table-column align="center" :label="$t('message.porderEncasement')" width="90"
          prop="porder_time_node.datetime_confirm">
        </el-table-column>
        <!-- 配送单报价 -->
        <el-table-column align="center" :label="$t('message.porderQuote')" width="90"
          prop="porder_time_node.datetime_offer">
        </el-table-column>
        <!-- 客户付款 -->
        <el-table-column align="center" :label="$t('message.customerPayment')" width="90"
          prop="porder_time_node.datetime_pay_submit">
        </el-table-column>
        <!-- 财务确认到账 -->
        <el-table-column align="center" :label="$t('message.financialConfirmationCoTheAccount')" width="140"
          prop="porder_time_node.datetime_pay_confirm">
        </el-table-column>
        <!-- 业务出货 -->
        <el-table-column align="center" :label="$t('message.businessShip')" width="90"
          prop="porder_time_node.datetime_delivery">
        </el-table-column>
        <!-- 客户签收 -->
        <el-table-column align="center" :label="$t('message.userSignFor')" width="90"
          prop="porder_time_node.datetime_client_receive">
        </el-table-column>
        <!-- 取消 -->
        <el-table-column align="center" :label="$t('message.cancel')" width="90"
          prop="porder_time_node.datetime_cancel">
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="paginationContainer">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
        :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    user_id: { type: Number }
  },
  data() {
    return {
      tableData: [],
      datas: {
        user_id: '',
        status: '',
        created_at_start: '',
        created_at_end: '',
        page: 1,
        pageSize: 50
      },
      statusList: [],
      total: 0
    };
  },
  computed: {

  },
  created() {
    // this.porderList();
    this.$api.porderApi.statusMap().then((res) => {
      this.statusList = res.data;
    });
  },
  methods: {
    // 订单列表
    porderList() {
      this.datas.user_id = this.user_id
      this.tableData = []
      this.$api.JapaneseOffice.porderList(this.datas).then(res => {
        this.tableData = res.data.data
        this.total = res.data.total
        console.log(res);
      })
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.porderList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.porderList();
    },
    // 搜索
    search() {
      this.datas.page = 1
      this.porderList();

    },
    // 重置
    reset() {
      this.datas = {
        user_id: '',
        status: '',
        created_at_start: '',
        created_at_end: '',
        page: 1,
        pageSize: 50
      }
      this.datas.page = 1
      this.porderList();
    }
  }
}
</script>
<style lang='scss' scoped>
.search {
  display: flex;
  margin-top: 12px;

  .item {
    margin-right: 24px;
  }
}

.table {
  margin: 24px 0;

  /deep/.el-table__cell .cell {
    padding: 0 5px;
  }
}

a {
  color: #b4272d;

  &:hover {
    text-decoration: underline;
  }
}
</style>